module.exports = __webpack_public_path__ + "static/img/yuyue.a3da9f53.png";